// @archigraph r8DljQiU
import { Container } from '../components/ui/Container';

export function PrivacyPage() {
  return (
    <div className="py-16">
      <Container className="max-w-2xl">
        <p className="text-xs uppercase tracking-widest text-primary mb-4 font-bold">
          // legal
        </p>
        <h1 className="text-2xl font-bold text-text mb-2">Privacy Policy</h1>
        <p className="text-xs text-text-lighter mb-10">Last updated: March 7, 2026</p>

        <div className="space-y-8 text-xs text-text-light leading-relaxed">
          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">1. Information We Collect</h2>
            <p className="mb-3">When you create an account, we collect your name, email address, and hashed password. We do not store plaintext passwords — authentication is handled by AWS Cognito.</p>
            <p>When you use ArchiGraph, we collect basic usage analytics (pages visited, features used) to improve the product. We do not collect or transmit your architecture files — those remain entirely on your local machine.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">2. How We Use Your Information</h2>
            <ul className="space-y-2">
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Account creation and authentication</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Delivering software updates to the desktop application</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Sending transactional emails (account verification, password reset)</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Improving ArchiGraph based on aggregate usage patterns</span></li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">3. Data Storage</h2>
            <p>Your account data is stored in AWS DynamoDB with encryption at rest. Authentication tokens are managed by AWS Cognito. All data is processed in the US-East-1 region. We retain your data for as long as your account is active.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">4. Data Sharing</h2>
            <p>We do not sell, rent, or share your personal information with third parties. We may share data only when required by law or to protect our rights.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">5. Cookies</h2>
            <p>We use essential cookies and local storage for authentication (JWT tokens). We do not use third-party tracking cookies. Analytics, if enabled, use privacy-respecting methods without cross-site tracking.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">6. Your Rights</h2>
            <p className="mb-3">You can:</p>
            <ul className="space-y-2">
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Access your personal data through your dashboard</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Update your name and preferences at any time</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Request deletion of your account and all associated data</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Export your data in a machine-readable format</span></li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">7. Security</h2>
            <p>We use industry-standard security measures including HTTPS for all communications, encrypted storage, and AWS security best practices. If you discover a vulnerability, please report it to security@archigraph.io.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">8. Contact</h2>
            <p>For privacy-related questions, contact us at privacy@archigraph.io.</p>
          </section>
        </div>
      </Container>
    </div>
  );
}
